import { type UseQueryOptions, useQuery } from 'react-query';

import { type IBillingInfo } from 'src/services/api/billing-info/types';
import { queryKeys } from 'src/services/api/constants';
import { GET_BILLING_INFO_PATH } from 'src/services/api/billing-info/constants';
import { apiClient } from 'src/services/api/client';
import { legacyFeatureFlags } from 'src/utils/legacy-feature-flags';

type IGetBillingInfoResponse = IBillingInfo;

export const useBillingInfo = (options?: Pick<UseQueryOptions, 'enabled'>) => {
    return useQuery(
        [queryKeys.billingInfo],
        async () => {
            if (legacyFeatureFlags.billing) {
                try {
                    return await apiClient(GET_BILLING_INFO_PATH).json<IGetBillingInfoResponse>();
                } catch (error) {
                    console.error(error);
                    return null;
                }
            } else {
                return null;
            }
        },
        {
            ...options,
            retry: false,
        }
    );
};
